// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lk-1";
export var messageSideRight = "_lk-2";
export var orderLookupBubbleContainer = "_lk-0";
export var submitButton = "_lk-3";